import useSWR, { mutate } from 'swr';

import { fetcherPost } from "../utils/axios";

const endpoints = {
    key: '/playlists',
    copy: '/copy',
    customer: '/customer',
}

export async function duplicateCustomerPlaylist(payload, currentCustomerId) {

    const data = await fetcherPost([endpoints.key + endpoints.copy, payload]);
    if (data?.success) mutate(endpoints.key + endpoints.customer + `/${currentCustomerId}`);
    else throw new Error(data?.error || 'Failed to duplicate customer playlist');

}